// extracted by mini-css-extract-plugin
module.exports = {"section":"valores_section__YJBE_","imageBackground":"valores_imageBackground__0e79_","card":"valores_card__V_1Fl","icons":"valores_icons__bblKl","image":"valores_image__VeRoo"};